import { makeApiCall } from "../apiRequest";

export default {
  state: {
    dashboardContent: [],
    graphContent: [],
  },
  getters: {
    getDashboardContent: (state) => state.dashboardContent,
    getGraphContent: (state) => state.graphContent,
  },
  actions: {
    async getDashboardContent({ commit }) {
      const url = `SuperAdminDashboard/superAdmin`;
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setDashboardContent", response.data.data);
      }
    },
    async getGraphContent({ commit }, year) {
      const url = `SuperAdminDashboard/superAdminDashboardBarChart?year=${year}`;
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setGraphContent", response.data.data);
      }
    },
    async sendOrganizationMessage(_, payload) {
      const response = await makeApiCall(
        `SuperAdminDashboard/sendOrganizationMessage`,
        "POST",
        payload
      );
      return response;
    },
  },
  mutations: {
    setDashboardContent: (state, payload) => (state.dashboardContent = payload),
    setGraphContent: (state, payload) => (state.graphContent = payload),
  },
};
